"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Break = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Break = function Break(_ref) {
  var vertical = _ref.vertical;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: function extend(_ref2) {
      var colors = _ref2.theme.colors;
      return {
        width: !vertical ? '100%' : 1,
        height: !vertical ? 1 : '100%',
        background: colors.border
      };
    }
  });
};

exports.Break = Break;